import { ROUTES as R } from '@aibees/elephant/router';
import { EnrichmentTypeEnum } from '@aibees/elephant/types';
import type { Enrichment } from '@aibees/shared/definition';

export const getEnrichmentSearchUrl = (item: Enrichment): string => {
  if (item.type === EnrichmentTypeEnum.COMPANY) {
    return `${R.searchCompany}?companies_enrichment_request_include=${item.name}%3A%3A${item.id}&modality=SAVED`;
  }

  if (item.type === EnrichmentTypeEnum.PERSON) {
    return `${R.searchPeople}?people_enrichment_request_include=${item.name}%3A%3A${item.id}&modality=SAVED`;
  }

  return '';
};

export const hasEnrichmentView = (item: Enrichment): boolean =>
  item.type === EnrichmentTypeEnum.COMPANY ||
  item.type === EnrichmentTypeEnum.PERSON;
